// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ConversationCountStatistics_header__WduA5 {
    margin-bottom: 25px;
}

.ConversationCountStatistics_title__SXzvD {
    font-size: 30px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/admin/components/ConversationCountStatistics/index.module.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB","sourcesContent":[".header {\n    margin-bottom: 25px;\n}\n\n.title {\n    font-size: 30px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `ConversationCountStatistics_header__WduA5`,
	"title": `ConversationCountStatistics_title__SXzvD`
};
export default ___CSS_LOADER_EXPORT___;
